import { Icon } from "@components/library";
import { COLORS } from "@constants";
import { Size } from "@tsTypes/index";
import { useState } from "react";
import styled from "styled-components";

interface Props {
  imageUrl?: string | null;
  isPrivate?: boolean;
  size?: Extract<Size, "xs" | "sm" | "md" | "lg" | "xl">;
  className?: string;
}

const OrganizationAvatar = ({ imageUrl, isPrivate = false, size = "lg", className }: Props) => {
  const [hasError, setHasError] = useState(false);

  const privateIconSize = ["sm", "md"].includes(size) ? "md" : size;

  return (
    <Container size={size} className={className}>
      {(() => {
        if (isPrivate) return <Icon name="Private Company" size={privateIconSize} />;
        if (imageUrl && !hasError)
          return <Avatar src={imageUrl} alt="" size={size} onError={() => setHasError(true)} />;
        return <Icon name="Organization" size={size} color={COLORS.NEUTRAL_400} />;
      })()}
    </Container>
  );
};

export default OrganizationAvatar;

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid ${COLORS.NEUTRAL_250};
  background-color: ${COLORS.WHITE};
  padding: 0 8px;
  ${({ size }) => {
    if (size === "xs") {
      return `
        width: 24px;
        height: 24px;
        min-width: 24px;
        min-height: 24px;
        border-radius: 4px;
      `;
    } else if (size === "sm") {
      return `
        width: 40px;
        height: 40px;
        min-width: 40px;
        min-height: 40px;
        border-radius: 4px;
      `;
    } else if (size === "md") {
      return `
        width: 48px;
        height: 48px;
        min-width: 48px;
        min-height: 48px;
        border-radius: 12px;
      `;
    } else if (size === "xl") {
      return `
        width: 90px;
        height: 90px;
        min-width: 90px;
        min-height: 90px;
        border-radius: 12px;
      `;
    }
    return `
      width: 64px;
      height: 64px;
      min-width: 64px;
      min-height: 64px;
      border-radius: 12px;
    `;
  }}
`;
const Avatar = styled.img`
  ${({ size }) => {
    if (size === "xs") {
      return `
        max-width: 18px;
        max-height: 18px;
      `;
    } else if (size === "sm") {
      return `
        max-width: 34px;
        max-height: 34px;
      `;
    } else if (size === "md") {
      return `
        max-width: 36px;
        max-height: 36px;
      `;
    }
    return `
      max-width: 48px;
      max-height: 48px;
    `;
  }}
`;
